import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const baseAdminCategoryFile = RepositoryFactory.get("baseAdminCategory");
export default {
    getCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.getCategoryData(payload);
                 commit("SET_CATEGORY", data.data.data);
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    addCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.addCategoryData(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    editCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.editCategoryData(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    deleteCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.deleteCategoryData(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    // sub category
    getSubCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.getSubCategoryData(payload);
                commit("SET_SUBCATEGORY", data.data.data);
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    addSubCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.addSubCategoryData(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    editSubCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.editSubCategoryData(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    deleteSubCategoryData({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await baseAdminCategoryFile.deleteSubCategoryData(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}